import {UIComponent} from "@webfruits/core";
import {Woman} from "./woman/Woman";
import {HotspotsData} from "../../data/HotspotsData";
import {Hotspot} from "./hotspots/Hotspot";
import {Size} from "../../style/Size";
import {gsap} from "gsap";
import {CoreServices} from "../../core/CoreServices";
import {AppConfig} from "../../config/AppConfig";

/******************************************************************
 * IllustrationSystem
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class IllustrationSystem extends UIComponent {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _woman: Woman;
    private _hotspots: Hotspot[] = [];
    private _transform3D: UIComponent;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(private _core: CoreServices) {
        super("illustration-system");
        this.initTransform3DBox();
        this.initWoman();
        this.initHotspots();
        this.initListeners();
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public playIntroAnimation() {
        this._hotspots.forEach((hotspot) => {
            hotspot.playIntroAnimation();
        })
        this._woman.playIntroAnimation();
    }

    public updateStyles() {
        this.applyStyle({
            position: "absolute",
            width: "100%",
            height: "100%",
            scale: 0.8,
            perspectiveOrigin: "center",
            perspective: 1200,
        })
        this._transform3D.applyStyle({
            position: "absolute",
            width: "100%",
            height: "100%",
            transformStyle: "preserve-3d",
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initTransform3DBox() {
        this._transform3D = new UIComponent("transform-3d");
        this.addChild(this._transform3D);
    }

    private initWoman() {
        this._woman = new Woman(this._core);
        this._transform3D.addChild(this._woman);
    }

    private initHotspots() {
        HotspotsData.items.forEach((data) => {
            const hotpsot = new Hotspot(data, this._core);
            this._hotspots.push(hotpsot);
            this.addChild(hotpsot)
        })
    }

    private initListeners() {
        window.addEventListener("mousemove", (e: MouseEvent) => this.onMouseMoved(e));
        document.addEventListener("mouseleave", () => this.mouseLeftDocument());
    }

    private updateRotation3D(e: MouseEvent) {
        let progressX = 0;
        let progressY = 0;
        if (e && !this._core.state.SELECTED_HOTSPOT.hasValue()) {
            progressY = e.clientY / Size.APP_HEIGHT - 0.5;
            progressX = e.clientX / Size.APP_WIDTH - 0.5;
        }
        gsap.to(this._transform3D.view, {
            duration: 1.5,
            overwrite: true,
            rotationY: -progressX * 30,
            rotationX: progressY * 5,
            ease: "power4.out"
        })
    }

    /******************************************************************
     * Events
     *****************************************************************/

    private onMouseMoved(e: MouseEvent) {
        this.updateRotation3D(e);
    }

    private mouseLeftDocument() {
        this.updateRotation3D(null);
    }

}
